import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../const';

const generateOrderNotification = (orders) => {
  if (orders === null || orders === undefined) {
    return null;
  }

  let list = [];
  orders.forEach((order) => {
    list.push({
      idx: order.idx,
      status: order.orderStatus,
      ftOrderCode: order.ftOrderCode,
      bmOrderCode: order.bmOrderCode,
      riderPhone: order.riderPhone,
      riderKey: order.userIdx,
    });
  });
  return list;
};

const generatePaymentNotification = (payments) => {
  if (payments === null || payments === undefined) {
    return null;
  }

  let paymentList = [];
  payments.forEach((payment) => {
    paymentList.push({ idx: payment.idx, payments: payment.orderPayments });
  });
  return paymentList;
};

const executeOrderNotification = (previousOrders, latestOrders, fn) => {
  if (!latestOrders || latestOrders.length === 0) {
    return;
  }

  previousOrders &&
    previousOrders.forEach((prev) => {
      const changedOrder = latestOrders.find(
        (latest) => prev.idx === latest.idx && prev.status < latest.status
      );
      const canceledOrder = latestOrders.find(
        (latest) => prev.idx === latest.idx && prev.status > latest.status
      );
      if (changedOrder !== undefined && canceledOrder === undefined) {
        fn && fn(changedOrder, false);
      } else if (changedOrder === undefined && canceledOrder !== undefined) {
        fn && fn(canceledOrder, true);
      }
    });

  previousOrders[0] &&
    previousOrders[0].idx < latestOrders[0].idx &&
    latestOrders.forEach((latest) => {
      const changedOrder = previousOrders.find(
        (prev) => prev.idx === latest.idx
      );
      if (!changedOrder) {
        fn && fn(latest, false);
      }
    });

  // previousOrders && previousOrders.forEach((prev) => {
  //     const changedOrder = latestOrders.find((latest) => prev.idx === latest.idx && prev.status === latest.status && prev.orderPayments !== latest.orderPayments);
  //     if(changedOrder !== undefined){
  //         fn && fn(changedOrder, 3);
  //     }
  // });
};

const executePaymentNotification = (previousPayment, latestPayment, fn) => {
  if (!latestPayment || latestPayment.length === 0) {
    return;
  }

  previousPayment &&
    previousPayment.forEach((prev) => {
      const changedPayment = latestPayment.find(
        (latest) =>
          prev.idx === latest.idx &&
          prev.payments.length > 0 &&
          latest.payments.length > 0 &&
          prev.payments[0].idx !== latest.payments[0].idx
      );
      if (changedPayment) {
        fn && fn();
      }
    });

  latestPayment.forEach((latest) => {
    const changedPayment = previousPayment.find(
      (prev) => prev.idx === latest.idx
    );
    if (!changedPayment) {
      fn && fn();
    }
  });
  // previousPayment && previousPayment.payments.length < latestPayment.payments.length && fn && fn()
};

const executeCompleteOrderNotification = (previousOrders, latestOrders, fn) => {
  if (!latestOrders || latestOrders.length === 0) {
    return;
  }
  latestOrders.forEach((latest) => {
    const changedOrder = previousOrders.find((prev) => prev.idx === latest.idx);
    if (!changedOrder) {
      fn && fn(latest);
    }
  });
};

const getUseNotifyOrderNew = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#notifyOrderNew');
  return typeof data === 'boolean' && data;
};
const SetUseNotifyOrderNew = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyOrderNew', data);
};

const getUseNotifyOrderAssign = () => {
  const data = reactLocalStorage.getObject(
    Const.appName + '#notifyOrderAssign'
  );
  return typeof data === 'boolean' && data;
};
const SetUseNotifyOrderAssign = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyOrderAssign', data);
};

const getUseNotifyOrderPickUp = () => {
  const data = reactLocalStorage.getObject(
    Const.appName + '#notifyOrderPickUp'
  );
  return typeof data === 'boolean' && data;
};
const SetUseNotifyOrderPickUp = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyOrderPickUp', data);
};

const getUseNotifyOrderComplete = () => {
  const data = reactLocalStorage.getObject(
    Const.appName + '#notifyOrderComplete'
  );
  return typeof data === 'boolean' && data;
};
const SetUseNotifyOrderComplete = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyOrderComplete', data);
};

const getUseNotifyOrderEtc = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#notifyOrderEtc');
  return typeof data === 'boolean' && data;
};
const SetUseNotifyOrderEtc = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyOrderEtc', data);
};

const getUseNotifyChat = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#notifyChat');
  return typeof data === 'boolean' && data;
};
const SetUseNotifyChat = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyChat', data);
};

// 배달의 민족 const
const getUseNotifyPosOrder = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#notifyPosOrder');
  return typeof data === 'boolean' && data;
};
const setUseNotifyPosOrder = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyPosOrder', data);
};
const getNotifyPosOrderPort = () => {
  const data = reactLocalStorage.getObject(
    Const.appName + '#notifyPosOrderPort'
  );
  const value = !data || data === '' ? Const.posOrderPort : parseInt(data);
  return isNaN(value) ? Const.posOrderPort : value;
};
const setNotifyPosOrderPort = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyPosOrderPort', data);
};

const getPosOrderAllowDuplicates = () => {
  const data = reactLocalStorage.getObject(
    Const.appName + '#posOrderAllowDuplicates'
  );
  return typeof data === 'boolean' && data;
};
const setPosOrderAllowDuplicates = (data) => {
  reactLocalStorage.setObject(Const.appName + '#posOrderAllowDuplicates', data);
};

// Sub Pos const
const getUseNotifyPosOrderRelationApp = () => {
  const data = reactLocalStorage.getObject(
    Const.appName + '#notifyPosOrderRelationApp'
  );
  return !data || !data.enable ? false : data.enable;
};
const setUseNotifyPosOrderRelationApp = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyPosOrderRelationApp', {
    enable: data,
  });
};
const getNotifyPosOrderRelationAppPort = () => {
  const data = reactLocalStorage.getObject(
    Const.appName + '#notifyPosOrderRelationAppPort'
  );
  const value =
    !data || !data.port ? Const.posOrderRelationAppPort : parseInt(data.port);
  return isNaN(value) ? Const.posOrderRelationAppPort : value;
};
const setNotifyPosOrderRelationAppPort = (data) => {
  reactLocalStorage.setObject(
    Const.appName + '#notifyPosOrderRelationAppPort',
    { port: data }
  );
};
const getPosOrderRelationAppAllowDuplicates = () => {
  const data = reactLocalStorage.getObject(
    Const.appName + '#posOrderRelationAppAllowDuplicates'
  );
  return !data || !data.enable ? false : data.enable;
};
const setPosOrderRelationAppAllowDuplicates = (data) => {
  reactLocalStorage.setObject(
    Const.appName + '#posOrderRelationAppAllowDuplicates',
    { enable: data }
  );
};

// CID const
const getUseNotifyCid = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#notifyCid');
  return typeof data === 'boolean' && data;
};
const setUseNotifyCid = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyCid', data);
};
const getNotifyCidPort = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#notifyCidPort');
  const value = !data || data === '' ? Const.cidPort : parseInt(data);
  return isNaN(value) ? Const.cidPort : value;
};
const setNotifyCidPort = (data) => {
  reactLocalStorage.setObject(Const.appName + '#notifyCidPort', data);
};

const getPreviousNotifyOrders = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#orders');
  return typeof data === 'object' && Array.isArray(data) ? data : [];
};
const getPreviousPaymentOrders = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#payments');
  return typeof data === 'object' && Array.isArray(data) ? data : [];
};
const setPreviousNotifyOrders = (data) => {
  reactLocalStorage.setObject(Const.appName + '#orders', data);
};

const setPreviousPaymentOrders = (data) => {
  reactLocalStorage.setObject(Const.appName + '#payments', data);
};

const getPreviousNotifyCompleteOrders = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#completeorders');
  return typeof data === 'object' && Array.isArray(data) ? data : [];
};
const setPreviousNotifyCompleteOrders = (data) => {
  reactLocalStorage.setObject(Const.appName + '#completeorders', data);
};

const getJibunAddress = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#getJibunAddr');
  return typeof data === 'boolean' ? data : true;
};
const setJibunAddress = (data) => {
  reactLocalStorage.setObject(Const.appName + '#getJibunAddr', data);
};
const getVrKeyboardSetting = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#keyboardSetting');
  return typeof data === 'boolean' && data;
};
const setVrKeyboardSetting = (data) => {
  reactLocalStorage.setObject(Const.appName + '#keyboardSetting', data);
};
const getUseAutoConfirmOrder = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#autoConfirmOrder');
  return typeof data === 'boolean' && data;
};
const setUseAutoConfirmOrder = (data) => {
  reactLocalStorage.setObject(Const.appName + '#autoConfirmOrder', data);
};
const getAutoConfirmPickupTime = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#autoConfirmPickupTime');
  return typeof data === 'number' && data ? data : Const.autoConfirmPickupTime;
};
const setAutoConfirmPickupTime = (data) => {
  reactLocalStorage.setObject(Const.appName + '#autoConfirmPickupTime', data);
};
const getPsBaeminSetting = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#psBaeminSetting');
  return typeof data === 'boolean' && data;
};
const setPsBaeminSetting = (data) => {
  reactLocalStorage.setObject(Const.appName + '#psBaeminSetting', data);
};
const getMultiPosSettings = () => {
  const data = reactLocalStorage.getObject(Const.appName + '#multiPosSetting');
  return typeof data === 'boolean' && data;
};
const setMultiPosSettings = (data) => {
  reactLocalStorage.setObject(Const.appName + '#multiPosSetting', data);
};

function convertToCSV(objArray) {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  var csv = '';

  for (var i = 0; i < array.length; i++) {
    var line = '';
    for (var index in array[i]) {
      if (line !== '') line += ',';

      line += array[i][index];
    }
    csv += line + '\r\n';
  }
  return csv;
}

function exportCSVFile(headers, items, fileTitle) {
  if (headers) {
    items.unshift(headers);
  }

  var jsonObject = JSON.stringify(items);
  var csv = convertToCSV(jsonObject);
  var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

  var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    var link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', exportedFilenmae);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

export {
  generateOrderNotification,
  executeOrderNotification,
  executeCompleteOrderNotification,
  generatePaymentNotification,
  executePaymentNotification,
  getPreviousPaymentOrders,
  setPreviousPaymentOrders,
  getUseNotifyOrderNew,
  SetUseNotifyOrderNew,
  getUseNotifyOrderAssign,
  SetUseNotifyOrderAssign,
  getUseNotifyOrderPickUp,
  SetUseNotifyOrderPickUp,
  getUseNotifyOrderComplete,
  SetUseNotifyOrderComplete,
  getUseNotifyOrderEtc,
  SetUseNotifyOrderEtc,
  getUseNotifyChat,
  SetUseNotifyChat,

  //Baemin 포트
  getUseNotifyPosOrder,
  setUseNotifyPosOrder,
  getNotifyPosOrderPort,
  setNotifyPosOrderPort,
  getPosOrderAllowDuplicates,
  setPosOrderAllowDuplicates,

  //Sub Pos 포트
  getUseNotifyPosOrderRelationApp,
  setUseNotifyPosOrderRelationApp,
  getNotifyPosOrderRelationAppPort,
  setNotifyPosOrderRelationAppPort,
  getPosOrderRelationAppAllowDuplicates,
  setPosOrderRelationAppAllowDuplicates,

  //CID 포트
  getUseNotifyCid,
  setUseNotifyCid,
  getNotifyCidPort,
  setNotifyCidPort,
  getPreviousNotifyOrders,
  setPreviousNotifyOrders,
  getPreviousNotifyCompleteOrders,
  setPreviousNotifyCompleteOrders,
  exportCSVFile,
  getJibunAddress,
  setJibunAddress,
  getVrKeyboardSetting,
  setVrKeyboardSetting,
  getUseAutoConfirmOrder,
  setUseAutoConfirmOrder,
  getAutoConfirmPickupTime,
  setAutoConfirmPickupTime,
  getPsBaeminSetting,
  setPsBaeminSetting,
  getMultiPosSettings,
  setMultiPosSettings,
};
